// material-ui
import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
// project imports
import MainCard from '../../components/MainCard';
import { AdminFeatures } from '../../utils/AdminFeatures/Features';
import { fetchBlogs } from '../../services/blogsService';
import ButtonComponent from '../../components/Buttons/Button';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router';
import CollapsibleTable from '../../sections/dashboard/default/CollapsibleTable';
import PaginatedTable from '../../sections/dashboard/default/PaginatedTable';
// ==============================|| SAMPLE PAGE ||============================== //

export default function CommonTable({tableHeads,title,feature,buttonText,buttonRoute,typo}) {
  const navigate = useNavigate();
  const [selectedFeature, setSelectedFeature] = useState(feature || AdminFeatures.USER_MANAGEMENT);
  return (
    <MainCard title={title}>
        <Box sx={{ display: "flex" }}>
      <ButtonComponent variant='contained' text={buttonText} align="right" onClick={() => navigate((buttonRoute))} sx={{ ml: "auto" }}/>
      </Box>

      <Grid size={{ xs: 12, md: 7, lg: 8 }}>
       
        <MainCard sx={{ mt: 2 }} content={false}>
          {feature === AdminFeatures.USER_MANAGEMENT ? 
           <CollapsibleTable tableHeads={tableHeads} feature={selectedFeature} />
          :  <PaginatedTable tableHeads={tableHeads} feature={selectedFeature} /> }
        </MainCard>
      </Grid>
    </MainCard>
  );
}
